import React, { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon, PhoneIcon, MailIcon } from 'lucide-react';
const FAQPage = () => {
  const [openIndex, setOpenIndex] = useState(0);
  const toggleFaq = index => {
    if (openIndex === index) {
      setOpenIndex(null);
    } else {
      setOpenIndex(index);
    }
  };
  const faqs = [{
    question: 'How Can I Contact Customer Support?',
    answer: <div data-id="element-322">
          <p className="mb-4" data-id="element-323">You can reach us by:</p>
          <div className="space-y-2 mb-4" data-id="element-324">
            <div className="flex items-center" data-id="element-325">
              <MailIcon size={18} className="text-[#3fc1c9] mr-2" data-id="element-326" />
              <span data-id="element-327">Email: Bikashbuddha2004@gmail.com</span>
            </div>
            <div className="flex items-center" data-id="element-328">
              <PhoneIcon size={18} className="text-[#3fc1c9] mr-2" data-id="element-329" />
              <span data-id="element-330">Phone: 0800 055 4969</span>
            </div>
          </div>
          <p data-id="element-331">
            Our support team is available Monday to Friday from 9 am to 5 pm.
            Messages received outside these hours will be responded to on the
            next working day.
          </p>
        </div>
  }, {
    question: 'When Does My Service Plan Start and End?',
    answer: <div data-id="element-332">
          <p className="mb-4" data-id="element-333">
            Your PinnacleHub coverage begins as soon as your payment is
            confirmed. For example, if you purchase a 12-month plan on 15 July,
            your protection lasts until 23:59 on 14 July the following year.
          </p>
          <p className="mb-4" data-id="element-334">
            <strong data-id="element-335">Activation:</strong> Your plan activates immediately after
            payment clears. A confirmation email will be sent straight away. No
            further action is needed on your part. Coverage lasts for 12 months
            from the purchase date (or 24 months for two-year plans).
          </p>
          <p data-id="element-336">
            <strong data-id="element-337">Expiry:</strong> Your plan ends exactly 12 months later at
            23:59 (or 24 months for two-year plans), unless you choose to renew
            for continuous protection.
          </p>
        </div>
  }, {
    question: 'How Do I Request a Repair?',
    answer: <div data-id="element-338">
          <p className="mb-4" data-id="element-339">Contact PinnacleHub at:</p>
          <div className="space-y-2 mb-4" data-id="element-340">
            <div className="flex items-center" data-id="element-341">
              <PhoneIcon size={18} className="text-[#3fc1c9] mr-2" data-id="element-342" />
              <span data-id="element-343">0800 055 4969</span>
            </div>
            <div className="flex items-center" data-id="element-344">
              <MailIcon size={18} className="text-[#3fc1c9] mr-2" data-id="element-345" />
              <span data-id="element-346">Bikashbuddha2004@gmail.com</span>
            </div>
          </div>
          <p data-id="element-347">
            We typically schedule repair appointments within 24 to 48 hours.
          </p>
        </div>
  }, {
    question: 'What does ", Unlimited, Repairs, " mean?',
    answer: <div data-id="element-348">
          <p className="mb-4" data-id="element-349">
            You may request unlimited repair visits and technician time for all
            essential appliances and systems covered under your PinnacleHub
            plan.
          </p>
          <p className="mb-4" data-id="element-350">
            Please note: Appliances older than 10 years, accidental or liquid
            damage, and general wear and tear not caused by mechanical or
            electrical faults are excluded.
          </p>
        </div>
  }, {
    question: 'Cooling-Off and Refunds',
    answer: <div data-id="element-351">
          <p className="mb-4" data-id="element-352">
            Yes. You can cancel within 14 days of purchase for a full refund,
            provided no repair work has started.
          </p>
          <p className="mb-4" data-id="element-353">
            Cancellations made between days 15 and 28 may be eligible for a
            partial refund, at our discretion, taking into account any services
            already rendered.
          </p>
          <p className="mb-4" data-id="element-354">No refunds are offered after 28 days.</p>
          <p className="mb-4" data-id="element-355">
            To cancel, email Bikashbuddha2004@gmail.com or call 0800 055 4969
            with your order number.
          </p>
          <p data-id="element-356">
            Refunds will be processed to your original payment method within 7
            to 10 working days.
          </p>
        </div>
  }, {
    question: 'What Appliances and Faults Are Covered?',
    answer: <div data-id="element-357">
          <p className="mb-4" data-id="element-358">
            <strong data-id="element-359">Included:</strong> Mechanical and electrical faults on
            registered appliances (e.g., breakdowns, faulty components).
          </p>
          <p data-id="element-360">
            <strong data-id="element-361">Excluded:</strong> Accidental or liquid damage, unregistered
            appliances, and appliances exceeding the age limit of 10 years.
          </p>
        </div>
  }];
  return <div data-id="element-362">
      {/* Hero Section */}
      <section className="bg-[#0a3d62] text-white py-16" data-id="element-363">
        <div className="container mx-auto px-4" data-id="element-364">
          <div className="max-w-3xl mx-auto text-center" data-id="element-365">
            <h1 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-366">
              Frequently Asked Questions
            </h1>
            <p className="text-lg text-gray-200" data-id="element-367">
              Find answers to common questions about our appliance repair
              services and service plans
            </p>
          </div>
        </div>
      </section>
      {/* FAQ Section */}
      <section className="py-16" data-id="element-368">
        <div className="container mx-auto px-4" data-id="element-369">
          <div className="max-w-3xl mx-auto" data-id="element-370">
            <p className="text-gray-700 mb-8" data-id="element-371">
              Here you'll find answers to common questions about PinnacleHub's
              appliance repair services and service plans. We aim to be as
              transparent as possible to give you complete peace of mind.
            </p>
            <div className="space-y-4" data-id="element-372">
              {faqs.map((faq, index) => <div key={index} className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-373">
                  <button className="flex justify-between items-center w-full p-4 text-left bg-white hover:bg-gray-50 transition-colors" onClick={() => toggleFaq(index)} data-id="element-374">
                    <h3 className="text-lg font-semibold text-[#0a3d62]" data-id="element-375">
                      {faq.question}
                    </h3>
                    {openIndex === index ? <ChevronUpIcon size={20} className="text-[#3fc1c9]" data-id="element-376" /> : <ChevronDownIcon size={20} className="text-[#3fc1c9]" data-id="element-377" />}
                  </button>
                  {openIndex === index && <div className="p-4 bg-gray-50 border-t border-gray-200" data-id="element-378">
                      <div className="text-gray-700" data-id="element-379">{faq.answer}</div>
                    </div>}
                </div>)}
            </div>
            {/* Contact Box */}
            <div className="mt-12 bg-[#e6f7f8] p-6 rounded-lg" data-id="element-380">
              <h3 className="text-xl font-semibold text-[#0a3d62] mb-4" data-id="element-381">
                Still Have Questions?
              </h3>
              <p className="text-gray-700 mb-6" data-id="element-382">
                If you couldn't find the answer to your question, please don't
                hesitate to contact our customer service team.
              </p>
              <div className="flex flex-wrap gap-4" data-id="element-383">
                <a href="tel:08000554969" className="bg-[#0a3d62] hover:bg-[#072f4a] text-white font-medium py-2 px-4 rounded-md transition-colors flex items-center" data-id="element-384">
                  <PhoneIcon size={18} className="mr-2" data-id="element-385" />
                  0800 055 4969
                </a>
                <a href="mailto:Bikashbuddha2004@gmail.com" className="bg-white hover:bg-gray-100 text-[#0a3d62] border border-[#0a3d62] font-medium py-2 px-4 rounded-md transition-colors flex items-center" data-id="element-386">
                  <MailIcon size={18} className="mr-2" data-id="element-387" />
                  Email Us
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>;
};
export default FAQPage;